export enum BootNames {
  i18n = 'i18n'
}
